function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: "0"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M3.18 11.74c1.65-3.37 5.03-5.5 8.82-5.5s7.17 2.13 8.82 5.5c-1.65 3.37-5.03 5.5-8.82 5.5s-7.17-2.13-8.82-5.5zm4.32 0c0 2.48 2.02 4.5 4.5 4.5s4.5-2.02 4.5-4.5-2.02-4.5-4.5-4.5-4.5 2.02-4.5 4.5z",
  opacity: ".3",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fillOpacity: ".87"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1 11.74c1.73-4.39 6-7.5 11-7.5s9.27 3.11 11 7.5c-1.73 4.39-6 7.5-11 7.5s-9.27-3.11-11-7.5zm2.18 0c1.65 3.37 5.03 5.5 8.82 5.5s7.17-2.13 8.82-5.5c-1.65-3.37-5.03-5.5-8.82-5.5s-7.17 2.13-8.82 5.5zM12 7.24c-2.48 0-4.5 2.02-4.5 4.5s2.02 4.5 4.5 4.5 4.5-2.02 4.5-4.5-2.02-4.5-4.5-4.5zm-2.5 4.5a2.5 2.5 0 005 0 2.5 2.5 0 00-5 0z",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fillOpacity: ".87"
}));